import { useInstance } from '../support/ioc/useInstance';
import { useEditableMissionState } from '../missions/model/useEditableMissionState.tsx';
import { OperatorState } from '../profile/OperatorState.ts';
import { useSubscription } from '@autopylot-internal/state';
import { MissionReport } from './MissionReport.ts';
import { useEffect, useState } from 'react';

export const DXMissionReport: React.FC<{ missionId: string; }> = ({ missionId }) => {
    const mission = useEditableMissionState(missionId);
    const operator = useInstance(OperatorState);
    useSubscription(() => operator);

    const reportBuilder = useInstance(MissionReport);

    const [pdfUrl, setPDFUrl] = useState('');

    useEffect(() => {
        if (!mission){
            return;
        }
        try {
            Promise.resolve().then(async () => {
                const pdf = await reportBuilder.buildPDF({
                    generatedAt: new Date().toISOString(),
                    operator: operator.state,
                    mission: mission
                });
                setPDFUrl(pdf.toBlobURI());
            });
        }
        catch (err) {
            console.log(err);
        }
    }, [mission, operator, reportBuilder]);

    return (
        <div style={{ height: '100%' }}>
            {/* this markup was 2 50% panes, but didn't refactor to simplify after it became one (b/c not a priority, this is a DX page) */}
            <div style={{ display: 'flex', height: '100%' }}>
                {pdfUrl && (
                    <iframe title='some-title' style={{ flexGrow: 1 }} src={pdfUrl} ></iframe>
                )}
            </div>
        </div>
    );
};
